/**
 * AxLabs Experiments - Biology Module Index
 *
 * Exports all biology experiments (both manual and generated).
 */
// ============================================================================
// MANUAL EXPERIMENTS
// ============================================================================
export { EnzymeKineticsSimulation, createEnzymeKinetics, ENZYME_KINETICS_CONFIG, } from './enzyme-kinetics.js';
export { PopulationDynamicsSimulation, createPopulationDynamics, POPULATION_DYNAMICS_CONFIG, } from './population-dynamics.js';
export { DiffusionSimulation, createDiffusion, DIFFUSION_CONFIG, } from './diffusion-osmosis.js';
// ============================================================================
// GENERATED EXPERIMENTS
// ============================================================================
// Export all generated experiments and category arrays
export { 
// Individual experiment exports by category
HardyWeinbergEquilibrium, GeneticDrift, NaturalSelectionDirectional, NaturalSelectionStabilizing, MutationRateEffects, GeneFlowBetweenPopulations, CompetitionLotkaVolterra, PredatorSaturationTypeII, PredatorSwitchingTypeIII, SIREpidemicModel, AgeStructuredPopulation, EnergyFlowTrophicLevels, FacilitatedDiffusion, ActiveTransportATP, SodiumPotassiumATPase, Chemiosmosis, 
// Category arrays
geneticsExperiments, ecologyExperiments, cellTransportExperiments, allBiologyExperiments, experimentCount as biologyExperimentCount, } from './generated/index.js';
// ============================================================================
// ALL BIOLOGY EXPERIMENTS ARRAYS
// ============================================================================
import { ENZYME_KINETICS_CONFIG } from './enzyme-kinetics.js';
import { POPULATION_DYNAMICS_CONFIG } from './population-dynamics.js';
import { DIFFUSION_CONFIG } from './diffusion-osmosis.js';
import { allBiologyExperiments as generatedBiologyExperiments } from './generated/index.js';
/**
 * Manual biology experiments - these use ExperimentConfig from simulation-core
 * Each has a dedicated SimulationEngine implementation
 */
export const MANUAL_BIOLOGY_EXPERIMENTS = [
    ENZYME_KINETICS_CONFIG,
    POPULATION_DYNAMICS_CONFIG,
    DIFFUSION_CONFIG,
];
/**
 * Generated biology experiments - these are GeneratedExperimentClass instances
 * created from ExperimentSchema using the declarative framework
 */
export const GENERATED_BIOLOGY_EXPERIMENTS = [
    ...generatedBiologyExperiments,
];
/**
 * Combined configs for backward compatibility.
 * For generated experiments, extracts the config from the class.
 */
export const BIOLOGY_EXPERIMENTS = [
    ...MANUAL_BIOLOGY_EXPERIMENTS,
    ...GENERATED_BIOLOGY_EXPERIMENTS.map((ExpClass) => {
        const instance = new ExpClass();
        return instance.config;
    }),
];
//# sourceMappingURL=index.js.map